import React from 'react';
import { Link } from 'react-router-dom';
import { useYearContext } from '../components/Layout.jsx';

export default function NotFound() {
  const { basePath } = useYearContext();

  return (
    <div className="empty" style={{ marginTop: '2rem' }}>
      <h3>Stránka nenalezena</h3>
      <p style={{ marginBottom: '1.25rem' }}>Odkaz nejspíš zastaral nebo obsahuje překlep.</p>
      <Link to={basePath || '/'} className="btn">Zpět na úvod</Link>
    </div>
  );
}
